import { Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useJwt } from "react-jwt";

export default function useCheckUserToken(accessToken) {
  const [isLoading, setIsLoading] = useState(true);
  const { decodedToken, isExpired } = useJwt(accessToken);

  useEffect(() => {
    if (accessToken) {
      setIsLoading(false);
    }
  }, [accessToken]);

  const tokenExpired = accessToken && !decodedToken ? true : isExpired; 
  return { decodedToken, isExpired: tokenExpired, isLoading };
}

export function getDateRange(startMMYYYY, endMMYYYY) {
  const [startMonth, startYear] = startMMYYYY.split('/').map(Number);
  const [endMonth, endYear] = endMMYYYY.split('/').map(Number);

  const startDate = `${startYear}-${String(startMonth).padStart(2, '0')}-01`;

  const lastDayOfEndMonth = new Date(endYear, endMonth, 0).getDate();
  const endDate = `${endYear}-${String(endMonth).padStart(2, '0')}-${lastDayOfEndMonth}`;

  return { startDate, endDate };
}

export const NoRecords = () => <div style={{
  display: 'flex',
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "80%"
}}>
  <Typography
    className={'primary-content'}
    variant={'h2'}
    sx={{
      fontFamily: 'Lato, sans-serif',
      fontSize: '18px',
      fontWeight: '400',
      lineHeight: '21.6px',
      textAlign: 'left',
      letterSpacing: '0.02em',
      color: 'rgba(84, 84, 84, 1)',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
    }}
  >
    No records
  </Typography>
</div>